import {
  Directive,
  ElementRef,
  forwardRef,
  Inject,
  Injector,
  Renderer2,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {PatternlibControlValueAccessorValueBase} from './accessor-base';

@Directive({
  selector:
    'patternlib-textinput,patternlib-textarea,patternlib-texttoggle,patternlib-radiobutton,patternlib-dropdown,patternlib-dropdownsubtle,patternlib-selection-card-group,patternlib-multiselect',
  host: {
    '(lhSelect)': "handleChangeEvent($event.target.value)",
    '(lhChange)': "handleChangeEvent($event.target.value)",
    '(lhSearchChange)': "handleChangeEvent($event.target.value)",
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PatternlibValueControlValueAccessor),
      multi: true,
    }
  ],
})
export class PatternlibValueControlValueAccessor
  extends PatternlibControlValueAccessorValueBase
{
  constructor(
    renderer: Renderer2,
    @Inject(Injector) injector: Injector,
    elementRef: ElementRef,
  ) {
    super(renderer, injector, elementRef);
  }
}
